import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Checkbox,
  Link,
  Grid,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import styles from "./signuplogin.module.css";
import { PiBuildingOfficeFill } from "react-icons/pi";
import { FaUser } from "react-icons/fa6";
import { ImOffice } from "react-icons/im";
import { FaMobile } from "react-icons/fa";
import { IoIosMailOpen } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { PiBuildings } from "react-icons/pi";
import WordAnimation from "./WordAnimation";
import logo from "../../assets/images/Latest Logo.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import "./loginsignup.css";
import { useFormik } from "formik";
import { GoLightBulb } from "react-icons/go";
import { RxHamburgerMenu } from "react-icons/rx";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import OTPInput from "react-otp-input";
import { resendOtp, signup, verifyOtp } from "../../redux/auth/authSlice";
import { ToastContainer } from "react-toastify";
import Spinner from "../../components/common/Spinner";
import Fade from "react-reveal/Fade";

const SignUp = () => {
  const [open, setOpen] = useState(false);
  const [mobile_otp, setMobile_otp] = useState("");
  const [errors, setErrors] = useState({});
  const [checked, setChecked] = useState(false);

  const formik = useFormik({
    initialValues: {
      full_name: "",
      company_name: "",
      mobile_no: "",
      email: "",
      role: "IT_RECRUITER",
    },
    validationSchema: Yup.object({
      full_name: Yup.string().required("Full Name is required"),
      company_name: Yup.string().required("Company Name is required"),
      mobile_no: Yup.string()
        .matches(/^\d+$/, "Mobile Number must be digits only")
        .required("Mobile Number is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    // onSubmit: values => {
    // },
  });

  const navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const handleChange = (code) => setMobile_otp(code);
  const isMobile = useMediaQuery("(max-width:600px)");

  const userData = useSelector((state) => state.auth.user);
  const authError = useSelector((state) => state.auth.error);
  const authStatus = useSelector((state) => state.auth.status);

  const validate = () => {
    const errors = {};
    if (!mobile_otp) errors.mobile_otp = "Otp is required";
    if (mobile_otp.length !== 6) errors.mobile_otp = "Otp should be 6 digit";
    return errors;
  };

  const handleOnClickSubmit = () => {
    if (
      Object.keys(formik.errors).length === 0 &&
      Object.keys(formik.touched).length !== 0
    ) {
      dispatch(signup(formik.values));
    }
  };

  const handleOnClickVerifyOtp = (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length === 0) {
      dispatch(
        verifyOtp({ mobile_otp, user_id: userData && userData?.user?.user_id })
      );
    } else {
      setErrors(errors);
    }
  };

  const handleOnClickResendOtp = () => {
    dispatch(resendOtp({ email: userData && userData?.user?.email }));
  };

  useEffect(() => {
    if (userData && authStatus === "signup_succeeded") {
      handleClickOpen();
    } else if (authStatus === "verify_otp_succeeded") {
      handleClose();
      navigate("/login");
    }
  }, [authError, userData, authStatus]);

  const handleFullNameChange = (event) => {
    const { value } = event.target;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      formik.setFieldValue("full_name", value);
    }
  };

  const handleMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) {
      formik.setFieldValue("mobile_no", value);
    }
  };

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      {/* {authStatus === "loading" && <Spinner />} */}
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>

        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact us
            </b>
          </a>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px  ",
                  fontWeight: "500",
                }}
              >
                Home
              </b>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </b>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                About us
              </b>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Contact us
              </b>
            </a>
          </Box>
        )}
      </Box>
      <Box className={styles.signup_details}>
        <Grid container>
          {!isMobile && (
            <Grid
              item
              xs={12}
              sm={12}
              md={7}
              lg={7}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0 0 0 100px",
                marginBottom: "35px",
              }}
            >
              <span>
                <br />
                <Box className={styles.text_details}>
                  {/* Typography Block for Desktop */}
                  <Typography
                    sx={{ marginBottom: "10px", fontSize: "25px !important" }}
                  >
                    <b>Hello IT Professional!</b>
                  </Typography>
                  <br />
                  <Typography
                    sx={{ marginBottom: "20px", fontSize: "17px !important" }}
                  >
                    We are happy to announce that
                    <br />
                    Daily 1000+ IT professionals are getting double benefits for
                    their
                    <br />
                    same effort with our AI-integrated job board and ATS.
                  </Typography>
                  <br />
                  <Typography
                    sx={{ fontSize: "17px !important", lineHeight: "2.5" }}
                  >
                    <IoCheckmarkCircleOutline /> Start exploring the beautiful
                    platform, no payment required.
                    <br />
                    <IoCheckmarkCircleOutline /> An advanced feature-loaded job
                    board and ATS.
                    <br />
                    <IoCheckmarkCircleOutline /> Easy to use and fast
                    forwarding.
                  </Typography>
                </Box>
              </span>
            </Grid>
          )}

          {isMobile && (
            <Grid
              item
              xs={12}
              sm={12}
              md={7}
              lg={7}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "65px 0 0 30px",
              }}
            >
              <span>
                <br />
                <Box sx={{ color: "#fff" }}>
                  <Typography
                    sx={{ marginBottom: "10px", fontSize: "20px !important" }}
                  >
                    <b>Hello IT Professional!</b>
                  </Typography>
                  <br />
                  <Typography
                    sx={{ marginBottom: "20px", fontSize: "16px !important" }}
                  >
                    We are happy to announce that
                    <br />
                    Daily 1000+ IT professionals are getting double benefits for
                    their same effort with our AI-integrated job board and ATS.
                  </Typography>
                </Box>
              </span>
            </Grid>
          )}
          <Fade bottom delay={100}>
            <Grid item xs={12} sm={6} md={5} lg={5}>
              <Box className={styles.box_contain}>
                <Box className={styles.text_contain}>
                  <Typography
                    sx={{
                      fontSize: "18px !important",
                      marginBottom: "10px",
                      padding: "0 15px 10px 25px",
                    }}
                  >
                    <b>Start using for free as IT Recruiter</b>
                  </Typography>
                  <form onSubmit={formik.handleSubmit}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        sx={{ padding: "0 10px" }}
                      >
                        <div
                          className="signup_form_group"
                          style={{ padding: "0 10px" }}
                        >
                          <span className="field_icon">
                            <FaUser />
                            <TextField
                              type="text"
                              name="full_name"
                              onChange={handleFullNameChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.full_name}
                              placeholder="Full Name"
                              sx={{
                                width: "100%",
                                backgroundColor: "#fff",
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    border: "none !important",
                                  },
                                },
                              }}
                            />
                          </span>
                          {formik.touched.full_name &&
                          formik.errors.full_name ? (
                            <div className="error">
                              {formik.errors.full_name}
                            </div>
                          ) : null}
                        </div>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        sx={{ padding: "0 10px" }}
                      >
                        <div
                          className="signup_form_group"
                          style={{ padding: "0 10px" }}
                        >
                          <span className="field_icon">
                            <FaMobile />
                            <TextField
                              type="number"
                              name="mobile_no"
                              placeholder="Phone Number"
                              onChange={handleMobileNoChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.mobile_no}
                              sx={{
                                width: "100%",
                                backgroundColor: "#fff",
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    border: "none !important",
                                  },
                                },
                              }}
                              inputProps={{
                                maxLength: 10,
                              }}
                            />
                          </span>
                          {formik.touched.mobile_no &&
                          formik.errors.mobile_no ? (
                            <div className="error">
                              {formik.errors.mobile_no}
                            </div>
                          ) : null}
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        sx={{ padding: "0 10px" }}
                      >
                        <div
                          className="signup_form_group"
                          style={{ padding: "0 10px" }}
                        >
                          <span className="field_icon">
                            <IoIosMailOpen />
                            <TextField
                              name="email"
                              placeholder="Work E-Mail ID"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.email}
                              sx={{
                                width: "100%",
                                backgroundColor: "#fff",
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    border: "none !important",
                                  },
                                },
                              }}
                            />
                          </span>
                          {formik.touched.email && formik.errors.email ? (
                            <div className="error">{formik.errors.email}</div>
                          ) : null}
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        sx={{ padding: "0 10px" }}
                      >
                        <div
                          className="signup_form_group"
                          style={{ padding: "0 10px" }}
                        >
                          <span className="field_icon">
                            <PiBuildingOfficeFill
                              style={{ fontSize: "44px " }}
                            />
                            <TextField
                              type="text"
                              name="company_name"
                              placeholder=" Company Name"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.company_name}
                              sx={{
                                width: "100%",
                                backgroundColor: "#fff",
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    border: "none !important",
                                  },
                                },
                              }}
                            />
                          </span>
                          {formik.touched.company_name &&
                          formik.errors.company_name ? (
                            <div className="error">
                              {formik.errors.company_name}
                            </div>
                          ) : null}
                        </div>
                      </Grid>
                    </Grid>
                  </form>

                  <Box className={styles.checkbox_contain}>
                    <Checkbox
                      checked={checked}
                      onChange={handleCheckboxChange}
                      color="primary"
                    />
                    <Typography>
                      By signing up, you agree to our{" "}
                      <Link href="/security">Terms of Service</Link>
                    </Typography>
                  </Box>
                  <Box
                    className={
                      checked ? styles.signup_btn : styles.signup_btn_disable
                    }
                  >
                    <button
                      type="submit"
                      onClick={handleOnClickSubmit}
                      disabled={!checked}
                      style={
                        authStatus === "loading" ? { padding: "7px 40px" } : {}
                      }
                    >
                      {authStatus === "loading" ? (
                        <CircularProgress size={12} sx={{ color: "#fff" }} />
                      ) : (
                        "Sign Up"
                      )}
                    </button>
                  </Box>
                </Box>
                <Box className={styles.account_contain}>
                  <Typography
                    variant="body2"
                    sx={{
                      position: { md: "relative", xs: "relative" },
                      bottom: { md: "20px", xs: "20px" },
                    }}
                  >
                    Have an account?{" "}
                    <Link onClick={() => navigate("/login")} href="#">
                      Sign In
                    </Link>
                  </Typography>

                  <Typography
                    sx={{
                      position: { md: "relative", xs: "relative" },
                      bottom: { md: "85px", xs: "0" },
                    }}
                  >
                    Switch to BenchSales Recruiter{" "}
                    <Link
                      onClick={() => navigate("/benchsales-signup")}
                      href="#"
                    >
                      Sign Up{" "}
                    </Link>{" "}
                    <FaArrowRightLong
                      style={{ color: "#3856a6", fontSize: "20px" }}
                    />
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Fade>
        </Grid>
      </Box>
      <Box
        sx={{
          padding: "40px 0 0 100px",
          display: { xs: "none", sm: "block" },
        }}
      >
        <WordAnimation />
      </Box>

      <Typography
        sx={{
          fontSize: "17px !important",
          padding: "10px 0 0 100px",
          display: { xs: "none", sm: "block" },
        }}
      >
        No payment required if you are not satisfied in it.
      </Typography>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        // onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ color: "#3856a6", marginTop: "10px" }}
        >
          {"Verify Otp!"}
        </DialogTitle>
        <DialogContent>
          <span>
            <OTPInput
              value={mobile_otp}
              onChange={handleChange}
              numInputs={6}
              separator={<span style={{ width: "8px" }}></span>}
              isInputNum={true}
              shouldAutoFocus={true}
              renderSeparator={<span>-</span>}
              renderInput={(props) => <input {...props} />}
              inputStyle={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                width: "54px",
                height: "54px",
                fontSize: "16px",
                color: "#000",
                fontWeight: "500",
                caretColor: "blue",
                margin: "10px",
              }}
              focusStyle={{
                border: "1px solid #CFD3DB",
                outline: "none",
              }}
            />
            {errors.mobile_otp && (
              <p className="login_error">{errors.mobile_otp}</p>
            )}
          </span>
          <p
            style={{
              float: "right",
              textDecoration: "underline",
              color: " #3856a6",
              cursor: "pointer",
            }}
            onClick={handleOnClickResendOtp}
          >
            Resend otp
          </p>
        </DialogContent>
        <DialogActions className="forgot_password_modal_btns">
          <Button onClick={handleOnClickVerifyOtp}>Verify</Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </Box>
  );
};

export default SignUp;
